import {
    AdjustmentOperation,
    AdjustmentType,
    CatalogItem,
    DemographicPrice,
    LineItemTemplate,
    LineItemTemplateCode,
    UnitType,
} from "types";
import { getCatalogItemsByUnitType } from "./Catalog";
import { getLineItemTemplateByCode } from "./LineItemTemplate";

export const getDefaultBuyoutPricingValues = () => {
    return {
        adjustmentAmount: 0,
        adjustmentOperation: AdjustmentOperation.MARKDOWN,
        adjustmentType: AdjustmentType.ABSOLUTE,
    };
};

// whenever the amount is configured, we need to use same amount for all demographic/equipment prices
export const generateBuyoutPricingCatalogItemPrices = (
    catalogItems: CatalogItem[],
    lineItemTemplates: LineItemTemplate[],
    unitType: UnitType,
    adjustmentAmount = 0,
    adjustmentOperation: AdjustmentOperation = AdjustmentOperation.MARKDOWN,
    adjustmentType: AdjustmentType = AdjustmentType.ABSOLUTE,
): DemographicPrice[] => {
    const items = getCatalogItemsByUnitType(catalogItems, unitType);
    const privateUpgradeTemplate = getLineItemTemplateByCode(lineItemTemplates, LineItemTemplateCode.PRIVATE_UPGRADE);
    const result = [
        {
            adjustmentAmount,
            adjustmentOperation,
            adjustmentType,
            template: { id: privateUpgradeTemplate!.id },
            catalogItem: items[0] ?? [],
        },
    ];
    return result;
};

export const generateBuyoutPricingDemographicPrices = (
    catalogItems: CatalogItem[],
    lineItemTemplates: LineItemTemplate[],
    adjustmentAmount = 0,
    adjustmentOperation: AdjustmentOperation = AdjustmentOperation.MARKDOWN,
    adjustmentType: AdjustmentType = AdjustmentType.ABSOLUTE,
): DemographicPrice[] => {
    return generateBuyoutPricingCatalogItemPrices(
        catalogItems,
        lineItemTemplates,
        UnitType.DEMOGRAPHIC,
        adjustmentAmount,
        adjustmentOperation,
        adjustmentType,
    );
};
